import axios from "axios";
import qs from "qs";
import { Message } from "element-ui";
// http://www.hbhxzb.com/hzjt-oa
// http://192.168.5.18:9099/hzjt-oa
var baseURL = process.env.VUE_APP_baseURL;
axios.defaults.timeout = 30000;
axios.defaults.baseURL = baseURL;
export { baseURL };
var baseURL1 = process.env.VUE_APP_oabaseURL;
// 第二个基础路径配置
export const instance = axios.create({
  baseURL: baseURL1
});
export { baseURL1 };
instance.defaults.timeout = 30000;
instance.defaults.headers.post["Content-Type"] =
  "application/json;charset=UTF-8";

//http request 拦截器
axios.interceptors.request.use(
  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    config.data = qs.stringify(config.data);
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Accept-Language": "zh-CN"
    };
    // if(token){
    //   config.params = {'token':token}
    // }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code !== 0) {
      Message.error(response.data.msg);
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

// export function patch(url, data = {}) {
//   return new Promise((resolve, reject) => {
//     axios.patch(url, data).then(
//       response => {
//         resolve(response.data);
//       },
//       err => {
//         reject(err);
//       }
//     );
//   });
// }

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

// export function put(url, data = {}) {
//   return new Promise((resolve, reject) => {
//     axios.put(url, data).then(
//       response => {
//         resolve(response.data);
//       },
//       err => {
//         reject(err);
//       }
//     );
//   });
// }
